import React from "react";
import _ from "lodash";

const ModifyEntryModal = ({
  position,
  onEditEntry,
  onCloseModal,
  onDeleteEntry,
  entries_params
}) => {
  const edit_entry = _.get(entries_params, "edit_entry", "Edit Entry");
  const delete_entry = _.get(entries_params, "delete_entry", "Delete Entry");

  return (
    <div className="entry-modal-container" onClick={onCloseModal}>
      <div style={{ top: position.y - 76 }} className="modify-options">
        <div className="option" onClick={onEditEntry}>
          {edit_entry}
        </div>
        <div className="option delete" onClick={onDeleteEntry}>
          {delete_entry}
        </div>
      </div>
    </div>
  );
};

export default ModifyEntryModal;
